// src/layouts/trafficmonitoring/routeFlows/schema.js

// Declarative schema: defines endpoint, value extraction method, and sorting order.
const routeFlowsSchema = [
  {
    id: 1,
    groupId: 1,
     name: "Egnatia Corridor (to West)",
    endPoint: "/latest_route_flows_egnatia_transformed",
    computeValue: (e) => e.value_in ?? 0,
    sort: "asc",
  },
  {
    id: 2,
    groupId: 2,
    name: "Egnatia Corridor (to East)",
    endPoint: "/latest_route_flows_egnatia_transformed",
    computeValue: (e) => e.value_out ?? 0,
    sort: "desc",
  },
  {
    id: 3,
    groupId: 3,
    name: "Vas. Olgas Corridor",
    endPoint: "/latest_route_flows_olgas_transformed",
    computeValue: (e) => e.value_in ?? 0,
    sort: "asc",
  },
  {
    id: 4,
    groupId: 4,
    name: "Leof. Nikis Corridor",
    endPoint: "/latest_route_flows_nikis_transformed",
    computeValue: (e) => e.value_out ?? 0,
    sort: "asc",
  },
  // Typical
  {
    id: 5,
    groupId: 1,
    name: "Egnatia Corridor (to West) Typical",
    endPoint: "/latest_route_flows_egnatia_with_typical",
    computeValue: (e) => e.typical_value_in ?? 0,
    sort: "asc",
  },
  {
    id: 6,
    groupId: 2,
     name: "Egnatia Corridor (to East) Typical",
    endPoint: "/latest_route_flows_egnatia_with_typical",
    computeValue: (e) => e.typical_value_out ?? 0,
    sort: "asc",
  },
  {
    id: 7,
    groupId: 3,
    name: "Vas. Olgas Corridor Typical",
    endPoint: "/latest_route_flows_olgas_with_typical",
    computeValue: (e) => e.typical_value_in ?? 0,
    sort: "asc",
  },
  {
    id: 8,
    groupId: 4,
    name: "Leof. Nikis Corridor Typical",
    endPoint: "/latest_route_flows_nikis_with_typical",
    computeValue: (e) => e.typical_value_out ?? 0,
    sort: "asc",
  },
];

export default routeFlowsSchema;
